// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==================== Project Management page ==================== */

/* Card grid: .lf-grid-auto (master responsive layer) auto-fits columns of at
   least --lf-grid-min, so 320px..ultrawide all get a sensible column count
   without a per-breakpoint column list. */
.project-mgmt-grid {
  --lf-grid-min: 320px;
  align-items: stretch;
}

.project-mgmt-state {
  width: 100%;
}

.card:hover {
  background-color: var(--card-hover) !important;
  border-color: var(--border-strong) !important;
  box-shadow: var(--shadow-md) !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/management/projectManagement/styles/project-management.css"],"names":[],"mappings":"AAAA,sEAAsE;;AAEtE;;0CAE0C;AAC1C;EACE,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,8CAA8C;EAC9C,6CAA6C;EAC7C,uCAAuC;AACzC","sourcesContent":["/* ==================== Project Management page ==================== */\n\n/* Card grid: .lf-grid-auto (master responsive layer) auto-fits columns of at\n   least --lf-grid-min, so 320px..ultrawide all get a sensible column count\n   without a per-breakpoint column list. */\n.project-mgmt-grid {\n  --lf-grid-min: 320px;\n  align-items: stretch;\n}\n\n.project-mgmt-state {\n  width: 100%;\n}\n\n.card:hover {\n  background-color: var(--card-hover) !important;\n  border-color: var(--border-strong) !important;\n  box-shadow: var(--shadow-md) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
